import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

const getSalesOrderHeaderComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/SalesOrderHeader/SalesOrderHeaderComparisonInfoD365`,
        payload,
    );
    return response.data;
};

export const useGetSalesOrderHeaderComparison = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const salesOrderNumber = payload.keys.salesOrderNumber as string;
    const orderID = payload.keys.orderID as number;

    return useQuery<IComparisonInfo[]>({
        queryKey: [
            "GetSalesOrderHeaderComparisonInfoD365",
            {
                orderID: orderID ?? null,
                dataAreaId: dataAreaId ?? null,
                salesOrderNumber: salesOrderNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!orderID || orderID <= 0 || !dataAreaId || !salesOrderNumber) {
                throw new Error(
                    "Invalid params for GetSalesOrderHeaderComparisonInfoD365",
                );
            }
            return getSalesOrderHeaderComparison(payload);
        },
        enabled:
            Boolean(
                !orderID || orderID <= 0 || !dataAreaId || !salesOrderNumber,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
